import React, { HTMLAttributeReferrerPolicy, PropsWithChildren } from 'react';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
import OpenInNewIcon from '../../../images/icons/open_in_new.svg';

const useStyle = makeStyles((theme) => {
  return {
    link: {
      color: theme.palette.text.brand,
      textDecoration: 'none',
      '&:hover': {
        color: theme.palette.text.brandActive,
      },
    },
  };
});

export const ExternalLink: React.FC<
  PropsWithChildren<{
    className?: string;
    target?: '_blank' | '_self' | '_parent' | '_top' | 'framename';
    rel?: string;
    referrerPolicy?: HTMLAttributeReferrerPolicy;
    href: string;
    testId?: string;
    showOpenInIcon?: boolean;
    title?: string;
  }>
> = ({
  className,
  target = '_blank',
  rel = 'noopener noreferrer',
  referrerPolicy = 'no-referrer',
  testId,
  href,
  children,
  showOpenInIcon,
  title,
  ...props
}) => {
  const classes = useStyle();
  const fullClassName = className ? classes.link + ' ' + className : classes.link;

  return (
    <a
      className={fullClassName}
      href={href}
      target={target}
      referrerPolicy={referrerPolicy}
      rel={rel}
      data-testid={testId}
      title={title}
      style={
        showOpenInIcon
          ? { display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }
          : {}
      }
      {...props}
    >
      {children}
      {showOpenInIcon && (
        <OpenInNewIcon style={{ width: '20px', height: '20px', marginLeft: '4px' }} />
      )}
    </a>
  );
};
